import { render, staticRenderFns } from "./PriceListTableRow.vue?vue&type=template&id=6033219f&scoped=true"
import script from "./PriceListTableRow.vue?vue&type=script&lang=js"
export * from "./PriceListTableRow.vue?vue&type=script&lang=js"
import style0 from "./PriceListTableRow.vue?vue&type=style&index=0&id=6033219f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033219f",
  null
  
)

export default component.exports